import cn from 'classnames';
import { useFormContext } from 'react-hook-form';
import { Card } from '@shared/ui';
import { getErrorMessages } from '@src/library/helpers/events/errorMessages';
import * as st from './styles.module.scss';
import { Address } from './ui/address';
import { Online } from './ui/online';

interface Props {
  mode: string;
}

export const Place = ({ mode }: Props): JSX.Element => {
  const {
    formState: { errors },
  } = useFormContext();

  const renderPlace = (mode: string) =>
    mode === 'O' ? (
      <Card className={cn(st.place, st.offline)}>
        <Address />
      </Card>
    ) : (
      <Card className={cn(st.place)}>
        <Online />
      </Card>
    );

  const errorMessage = getErrorMessages(errors, ['external_service']);

  return (
    <fieldset className={st.wrapper}>
      <div className={st.header}>
        <h3>Место встречи</h3>
        <p>{errorMessage}</p>
      </div>
      {renderPlace(mode)}
    </fieldset>
  );
};
